import React, { Fragment, useCallback, useMemo } from "react";

import Button from "devextreme-react/button";
import { LoadIndicator } from "devextreme-react/load-indicator";
import { useTranslation } from "react-i18next";
import { useLoader } from "saga-query/react";

import {
  Case,
  CaseElse,
  Switch,
  useReverseRoute,
  useWindowDimensions,
} from "@app/contexts";
import { selectedGroupData, useAppDispatch, useAppSelector } from "@app/state";
import { downloadDistro } from "@app/state/units";

import { DemoContent } from "./demo";
import "./distro.scss";

import type { IGroupMember } from "@app/types";
export const DistributionMain = (props: { distro: number }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { routeInit } = useReverseRoute("distribution");
  const loader = useLoader(downloadDistro);
  const theDistro: IGroupMember = useAppSelector((s) =>
    selectedGroupData(s, +props.distro)
  );

  const buttonLabel = useMemo(() => {
    switch (loader?.status) {
      case "loading":
        return t("Download in progress ");
      case "success":
        return t("Download again");
      default:
        return `${t("Download")} ${theDistro?.GROUP_NAME}`;
    }
  }, [loader?.status, theDistro.GROUPID]);

  const buttonIcon = useMemo(() => {
    switch (loader?.status) {
      case "loading":
        return "progress";
      case "success":
        return "refresh";
      default:
        return "download";
    }
  }, [loader?.status]);

  const dowloadClick = useCallback(() => {
    dispatch(downloadDistro());
  }, []);

  return (
    <div ref={routeInit}>
      <h1 className="someUnderline">{theDistro?.GROUP_NAME}</h1>
      <Switch value={theDistro?.PERSEED}>
        <Case when={[(perse: string) => perse && perse.startsWith("DEMO")]}>
          <DemoContent groupData={theDistro}>
            <div className="wrapDownloadButton">
              <Button
                id={"download_demo_0"}
                width={364}
                height={64}
                stylingMode={"outlined"}
                // text={buttonLabel}
                onClick={dowloadClick}
                // icon={buttonIcon}
                visible={true}
                disabled={loader?.status === "loading"}
              >
                <div className="another-important-wrapper">
                  <Switch value={buttonIcon}>
                    <Case when={"progress"}>
                      <LoadIndicator className="button-indicator" />
                    </Case>
                    <Case when={"refresh"}>
                      <i className="dx-icon dx-icon-refresh" />
                    </Case>
                    <CaseElse>
                      <i className="dx-icon dx-icon-download" />
                    </CaseElse>
                  </Switch>
                </div>
                <span style={{ margin: "auto" }} className="dx-button-text">
                  {buttonLabel}
                </span>
              </Button>
            </div>
          </DemoContent>
        </Case>
        <CaseElse>
          <p>{"Detaliile ajutatoare le gasiti la sectiunea Demo."}</p>
          <div className="wrapDownloadButton">
            <Button
              id={"download_demo_0"}
              width={364}
              height={64}
              stylingMode={"outlined"}
              // text={buttonLabel}
              onClick={dowloadClick}
              // icon={buttonIcon}
              visible={true}
              disabled={loader?.status === "loading"}
            >
              <div className="another-important-wrapper">
                <Switch value={buttonIcon}>
                  <Case when={"progress"}>
                    <LoadIndicator className="button-indicator" />
                  </Case>
                  <Case when={"refresh"}>
                    <i className="dx-icon dx-icon-refresh" />
                  </Case>
                  <CaseElse>
                    <i className="dx-icon dx-icon-download" />
                  </CaseElse>
                </Switch>
              </div>
              <span style={{ margin: "auto" }} className="dx-button-text">
                {buttonLabel}
              </span>
            </Button>
          </div>
        </CaseElse>
      </Switch>
    </div>
  );
};
